import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['visibility1', 'visibility3']

  connect () {
    this.visibility(parseInt(document.querySelector('#activity_state_id, #activities_page_state_id').value))
  }

  visibleChange (event) {
    this.visibility(Number(event.currentTarget.value))
  }

  visibility (value) {
    switch (value) {
      case -1:
        this.visibility1Target.style.display = 'block'
        this.visibility3Target.style.display = 'none'
        this.visibility1Target.querySelector('select').disabled = false
        break
      case -2:
        this.visibility1Target.style.display = 'none'
        this.visibility3Target.style.display = 'none'

        this.visibility1Target.querySelector('select').disabled = true
        break
      default:
        this.visibility1Target.style.display = 'none'
        this.visibility3Target.style.display = 'block'
        this.visibility1Target.querySelector('select').disabled = false
    }
  }
}
